import { ArrowUpRight, ArrowRight } from "lucide-react";

const talks = [
  {
    venue: "CNBC",
    title: "Interview on creative leadership and the future of advertising.",
    href: "https://www.youtube.com/watch?v=XHfp_HgmVKw",
    thumb: "https://img.youtube.com/vi/W33Gzc2Xvz0/maxresdefault.jpg",
  },
  {
    venue: "e4m Tech Manch",
    title: "On building work that is culturally resonant and commercially effective.",
    href: "https://youtu.be/QktybD2susk?si=3DunK8mKAjYLx_5X",
    thumb: "https://img.youtube.com/vi/QktybD2susk/maxresdefault.jpg",
  },
  {
    venue: "AgencyCon",
    title: "On craft, courage, and the work that earns its place.",
    href: "https://www.youtube.com/watch?v=dl_bf3WI3nU",
    thumb: "https://img.youtube.com/vi/dl_bf3WI3nU/maxresdefault.jpg",
  },
  {
    venue: "Recent Talk",
    title: "On creative leadership and conversations that matter.",
    href: "https://www.youtube.com/watch?v=v6YSCf_QXWA",
    thumb: "https://img.youtube.com/vi/v6YSCf_QXWA/maxresdefault.jpg",
  },
];

export default function Speaking() {
  return (
    <section
      id="speaking"
      data-testid="speaking-section"
      className="relative py-28 md:py-36 bg-white border-t border-black/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="reveal max-w-3xl mb-16 md:mb-20">
          <div className="text-[11px] uppercase tracking-[0.28em] text-[#6B6B6B] mb-5 font-medium">
            03. On Stage
          </div>
          <h2 className="font-display text-[#0A0A0A] text-[34px] sm:text-[44px] lg:text-[56px] font-medium leading-[1.08] tracking-[-0.025em]">
            On stage
          </h2>
          <p className="mt-6 text-[16px] md:text-[18px] text-[#3A3A3A] leading-[1.65] max-w-2xl">
            Conversations on creative leadership, building bold brands, and the
            work it takes to grow into clearer, braver decision-makers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          {talks.map((t, i) => (
            <a
              key={t.href}
              href={t.href}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`talk-${i}`}
              className="reveal group block"
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <div className="overflow-hidden bg-[#FAFAF8] border border-black/5 rounded-sm aspect-video relative">
                <img
                  src={t.thumb}
                  alt={`${t.venue} talk thumbnail`}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                />
                <span className="absolute top-4 right-4 h-9 w-9 rounded-full bg-white/90 backdrop-blur grid place-items-center text-[#0A0A0A] opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <ArrowUpRight size={16} />
                </span>
                <span className="absolute inset-0 grid place-items-center pointer-events-none">
                  <span className="h-14 w-14 rounded-full bg-white/95 backdrop-blur grid place-items-center transition-transform duration-500 group-hover:scale-110">
                    <span
                      aria-hidden
                      className="block h-0 w-0 border-y-[8px] border-y-transparent border-l-[12px] border-l-[#0A0A0A] ml-1"
                    />
                  </span>
                </span>
              </div>
              <div className="mt-5">
                <div className="text-[11px] uppercase tracking-[0.22em] text-[#6B6B6B] font-medium">
                  {t.venue}
                </div>
                <h3 className="mt-2 font-display text-[18px] md:text-[20px] text-[#0A0A0A] font-medium leading-[1.35] tracking-[-0.015em]">
                  {t.title}
                </h3>
              </div>
            </a>
          ))}
        </div>

        <div className="reveal mt-16 md:mt-20">
          <a
            href="mailto:binaiferdulani@gmail.com"
            data-testid="speaking-cta-invite"
            className="group inline-flex items-center gap-2 rounded-full bg-[#0A0A0A] hover:bg-[#1F1F1F] text-white px-7 py-3.5 text-[14px] font-medium transition-all duration-300"
          >
            Connect for a speaking gig
            <ArrowRight
              size={15}
              className="transition-transform duration-300 group-hover:translate-x-1"
            />
          </a>
        </div>
      </div>
    </section>
  );
}
